<template>
  <div class="card p-4 flex items-start gap-3 transition-all duration-200 hover:shadow-card hover:-translate-y-0.5 hover:border-brand-200 group">
    <div class="w-9 h-9 rounded-lg bg-ink-50 text-ink-700 flex items-center justify-center shrink-0 transition-colors group-hover:bg-brand-50 group-hover:text-brand-700">
      <Icon :name="icon" :size="16" />
    </div>
    <div class="min-w-0">
      <div class="text-sm font-semibold text-ink-900 truncate">{{ name }}</div>
      <div class="text-xs text-ink-500 mt-0.5 truncate">{{ tag }}</div>
    </div>
  </div>
</template>

<script setup>
import Icon from '../ui/Icon.vue';
defineProps({
  name: { type: String, required: true },
  tag:  { type: String, default: '' },
  icon: { type: String, default: 'check' },
});
</script>
